var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donut-container"},[_c('vue-c3',{ref:"donut-chart",staticStyle:{"height":"100%"},attrs:{"handler":_vm.handler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }